module.exports = __webpack_public_path__ + "static/media/report-nav-icon.30390c56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/light-nav-images/report-nav-icon.svg
// module id = 571
// module chunks = 0